import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import { useGetTranslations } from '~/composables/useGetTranslations';
export default defineComponent({
  name: 'TheBibliography',
  props: {
    bibliography: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var filteredBibliography = computed(function () {
      return props.bibliography.filter(function (item) {
        var _item$fields;
        return ((_item$fields = item.fields) === null || _item$fields === void 0 ? void 0 : _item$fields.title) || item.title;
      });
    });
    var getTitle = function getTitle(item) {
      var _ref, _item$fields$title, _item$fields2;
      return (_ref = (_item$fields$title = item === null || item === void 0 ? void 0 : (_item$fields2 = item.fields) === null || _item$fields2 === void 0 ? void 0 : _item$fields2.title) !== null && _item$fields$title !== void 0 ? _item$fields$title : item === null || item === void 0 ? void 0 : item.title) !== null && _ref !== void 0 ? _ref : '';
    };
    var getText = function getText(item) {
      var _ref2, _item$fields$text, _item$fields3;
      return (_ref2 = (_item$fields$text = item === null || item === void 0 ? void 0 : (_item$fields3 = item.fields) === null || _item$fields3 === void 0 ? void 0 : _item$fields3.text) !== null && _item$fields$text !== void 0 ? _item$fields$text : item === null || item === void 0 ? void 0 : item.text) !== null && _ref2 !== void 0 ? _ref2 : '';
    };
    var hasLink = function hasLink(string) {
      var linkRegex = /(http(s)?:\/\/[^\s]+)/g;
      return linkRegex.test(string);
    };
    return {
      translate: translate,
      filteredBibliography: filteredBibliography,
      getTitle: getTitle,
      getText: getText,
      hasLink: hasLink
    };
  }
});